import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Home = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9254 12.8C21.0455 12.92 21.2056 12.98 21.3657 12.98L21.3557 12.97C21.5158 12.97 21.6859 12.91 21.806 12.79C22.0561 12.55 22.0661 12.16 21.826 11.92L13.4809 3.54C13.1307 3.19 12.6604 3 12.1601 3C11.6598 3 11.1895 3.19 10.8293 3.54L2.19404 11.93C1.94389 12.17 1.93388 12.56 2.17403 12.8C2.41417 13.04 2.80441 13.04 3.05456 12.8L11.6998 4.42C11.94 4.19 12.3502 4.19 12.5804 4.42L20.9254 12.8ZM13.721 21H18.7241C19.0743 21 19.3645 20.72 19.3645 20.38L19.4845 13.59C19.4945 13.25 19.2244 12.97 18.8742 12.97C18.5239 12.97 18.2338 13.25 18.2338 13.59L18.1237 19.76H14.3714L14.4515 15.44C14.4715 14.42 13.641 13.59 12.6103 13.59H11.3596C10.319 13.59 9.46844 14.42 9.44842 15.44L9.36838 19.76H5.6161L5.72616 13.59C5.73617 13.25 5.466 12.97 5.11579 12.97C4.76558 12.97 4.4754 13.25 4.4754 13.59L4.35533 20.38C4.34532 20.72 4.62549 21 4.9657 21H9.96874C10.319 21 10.6091 20.72 10.6091 20.38L10.6992 15.44C10.7092 15.1 10.9994 14.82 11.3396 14.82H12.5903C12.9305 14.82 13.2007 15.1 13.2007 15.44L13.1107 20.38C13.1006 20.72 13.3808 21 13.721 21Z"
    />
  </svg>
)

export default withDefaultStyles(Home)
